// import React, { useCallback } from "react";
// import { useCart } from "../../context/CartContext";
// import { Link } from "react-router-dom";
// import { Minus, Plus } from "lucide-react";
// import { motion } from "framer-motion";

// function CartItemsInCart({ item }) {
//   const { updateQuantity, removeItem } = useCart();

//   const {
//     _id,
//     thumbnail: image,
//     slug,
//     title,
//     variantName,
//     quantity,
//     price,
//     subtotal,
//     mrp,
//   } = item;

//   const numPrice = Number(price);
//   const numMrp = Number(mrp);

//   const handleRemove = useCallback(() => {
//     removeItem(item._id);
//   }, [removeItem, item._id]);

//   const handleQuantityChange = useCallback(
//     (delta) => {
//       const newQuantity = quantity + delta;
//       if (newQuantity < 1) return;

//       console.log(newQuantity);
//       updateQuantity(_id, newQuantity);
//     },
//     [updateQuantity, _id, quantity],
//   );

//   return (
//     <>
//       <motion.div
//         key={_id}
//         layout
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         exit={{ opacity: 0, scale: 0.9 }}
//         className="cart-item-card d-flex align-items-center"
//       >
//         {/* Unique Leaf Shape Image */}
//         <div className="cart-img-container me-4">
//           <img src={image} alt={title} className="cart-img" />
//         </div>

//         {/* Details */}
//         <div className="flex-grow-1">
//           <div className="d-flex justify-content-between align-items-start">
//             <div>
//               <h5 className="font-serif mb-1">{title}</h5>
//               <p className="text-muted small mb-0">{variantName}</p>
//             </div>
//             <div className="text-end d-none  d-lg-block">
//               <span className="font-serif fs-5">
//                 ₹ {price.toLocaleString()}
//               </span>
//             </div>
//           </div>

//           {/* Controls */}
//           {/* <div className="d-flex justify-content-between align-items-center mt-3">
//             <div className="qty-pill">
//               <button
//                 onClick={() => handleQuantityChange(-1)}
//                 className="qty-btn"
//               >
//                 <Minus size={14} />
//               </button>
//               <span className="qty-val">{quantity}</span>
//               <button
//                 onClick={() => handleQuantityChange(+1)}
//                 className="qty-btn"
//               >
//                 <Plus size={14} />
//               </button>
//             </div>

          
//             <span className="font-serif fs-5 d-lg-none price-responsive">
//               ₹ {(price * quantity).toLocaleString()}
//             </span>

//             <button onClick={handleRemove} className="remove-btn">
//               Remove
//             </button>
//           </div> */}


//             <div className="d-flex  gap-5">
//                       <div className="custom-cart-qty-toggle">
//                         <Minus
//                           size={12}
//                           className="pointer    custom-plus-icon"
//                           onClick={() => handleQuantityChange(-1)}
//                         />
//                          <input
                         
//                           type="number"
//                           value={quantity}
//                           readOnly
//                         />
//                         <Plus
//                           size={12}
//                           className="pointer   custom-plus-icon"
//                           onClick={() => handleQuantityChange(+1)}
//                         />
//                       </div>

//                        <div className="text-end  d-lg-none">
//               <span className="font-serif fs-5">
//                 ₹ {price.toLocaleString()}
//               </span>
//             </div>
//                     </div>
//         </div>
//       </motion.div>
//     </>
//   );
// }

// export default CartItemsInCart;





import React, { useCallback } from "react";
import { useCart } from "../../context/CartContext";
import { Link } from "react-router-dom";
import { Minus, Plus } from "lucide-react";
import { motion } from "framer-motion";

function CartItemsInCart({ item }) {
  const { updateQuantity, removeItem } = useCart();

  const {
    _id,
    thumbnail: image,
    slug,
    title,
    variantName,
    quantity,
    price,
    subtotal,
    mrp,
  } = item;

  const numPrice = Number(price);
  const numMrp = Number(mrp);

  const handleRemove = useCallback(() => {
    removeItem(item._id);
  }, [removeItem, item._id]);

  const handleQuantityChange = useCallback(
    (delta) => {
      const newQuantity = quantity + delta;
      if (newQuantity < 1) return;

      console.log(newQuantity);
      updateQuantity(_id, newQuantity);
    },
    [updateQuantity, _id, quantity],
  );

  return (
    <>
      <motion.div
        key={_id}
        layout
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.9 }}
        className="cart-item-card d-flex align-items-center"
      >
        {/* Unique Leaf Shape Image */}
        <div className="cart-img-container ">
          <img src={image} alt={title} className="cart-img" />
        </div>

        {/* Details */}
        <div className="flex-grow-1 m-3">
          <div className="d-flex justify-content-between align-items-start">
            <div>
              <h5 className="font-serif mb-1">{title}</h5>
              <p className="text-muted small mb-0">{variantName}</p>
            </div>
            <div className="text-end d-none d-lg-block">
              <span className="font-serif fs-5">
                ₹ {price.toLocaleString()}
              </span>
            </div>
          </div>

          {/* Controls */}
          <div className="d-flex justify-content-between align-items-center mt-3  "  >
            <div className="qty-pill">
              <button
                onClick={() => handleQuantityChange(-1)}
                className="qty-btn"
              >
                <Minus size={14} />
              </button>
              <span className="qty-val">{quantity}</span>
              <button
                onClick={() => handleQuantityChange(+1)}
                className="qty-btn"
              >
                <Plus size={14} />
              </button>
            </div>

            {/* Mobile Price */}
            <span className="font-serif fs-5 d-lg-none price-responsive">
              ₹ {(price * quantity).toLocaleString()}
            </span>

            {/* <button onClick={handleRemove} className="remove-btn">
              Remove
            </button> */}
             <button onClick={handleRemove} className=" d-none d-lg-block  btn-leaf-action">
              Remove
            </button>
          </div>

          <button onClick={handleRemove} className="d-lg-none  btn-leaf-action">
              Remove
            </button>
        </div>
      </motion.div>
    </>
  );
}

export default CartItemsInCart;
